import React, {
  createContext,
  FC,
  PropsWithChildren,
  useMemo,
  useReducer,
  useState,
} from 'react';

interface NewEvent {
  name: string;
  payload?: any;
}

type Events = Record<string, { payload?: any }>;

export const EventContext = createContext<{
  setEvents?: (event: NewEvent) => void,
  events?: Record<string, any>,
}>({});

export const EventProvider: FC<PropsWithChildren> = ({ children }) => {
  const [updated, setUpdated] = useState<any>();
  const [events, setEvents] = useReducer((prevEvents: Events, event: NewEvent) => {
    prevEvents[event.name] = event.payload || {};
    setUpdated({});
    return prevEvents;
  }, {});

  const updatedEvents = useMemo(() => events, [updated]);

  return (
    <EventContext.Provider value={{ setEvents, events: updatedEvents }}>
      {children}
    </EventContext.Provider>
  );
};
